<template>
  <div class="p-20">
    <van-form ref="form" :show-error="false" error-message-align="right">
      <van-cell-group>
        <van-field v-f-show="'flowNo'" :required="isRequired('flowNo')" v-model="formData.flowNo"
                   :rules="getRules('flowNo')" label="编号" input-align="right" readonly/>
        <van-field v-f-show="'ssbm'" input-align="right" name="ssbm" :required="isRequired('ssbm')"
                   :value="formData.ssbm" label="部门" :rules="getRules('ssbm')" placeholder="请选择部门">
          <template #input>
            <view-item @click.native="isShowPopup(ssbm,'ssbm')" :value="formData.ssbm" placeholder="请选择部门"/>
            <van-popup v-model="ssbm.show" position="bottom">
              <van-nav-bar title="选择部门" left-text="取消" right-text="确定" @click-left="ssbm.show = false"
                           @click-right="popupSubmit('ssbm',{label:'label',value:'value'})"/>
              <van-search v-model="ssbm.filterText" @input="pickerSearch($event,ssbm,'label')" clearable shape="round"/>
              <van-picker ref="ssbm" value-key="label" :columns="ssbm.filteredData" @cancel="ssbm.show = false"/>
            </van-popup>

          </template>
        </van-field>
        <van-field v-f-show="'sy'" v-model="formData.sy" :readonly="isDisabled('sy')" :required="isRequired('sy')" name="sy" :rules="getRules('sy')" type="textarea" maxlength="200" rows="3" autosize label="出差事由" show-word-limit placeholder="请输入出差事由" input-align="right"/>

        <van-field v-f-show="'ccsj'" :value="formData.ccsj[0]" :required="isRequired('ccsj')" name="ccsj" label="出差时间"
                   placeholder="出差时间" input-align="right" :rules="getRules('ccsj')">
          <template #input>
            <view-item @click.native="isShowPopup(ccsj,'ccsj')" :value="formData.ccsj.length > 1 ? `${formData.ccsj[0]} - ${formData.ccsj[1]}` : ''" placeholder="请选择出差时间"/>
            <van-calendar :min-date="new Date(2010, 1, 1)" v-model="ccsj.show" allow-same-day ref="ccsj" type="range" :show-confirm="false" title="选择出差时间"
                          @confirm="ccsjConfirm"></van-calendar>
          </template>
        </van-field>


        <van-field v-f-show="'ccts'" :disabled="isDisabled('ccts')" v-model="formData.ccts" type="number" name="ccts" :rules="getRules('ccts')" :required="isRequired('ccts')" :maxlength="8" placeholder="请输入出差天数" label="出差天数" input-align="right"></van-field>


        <van-field v-f-show="'fj'"  class="fileValueBox"  :value.prop="formData.fj" input-align="right" name="fj" :required="isRequired('fj')" :rules="getRules('fj')" label="附件" placeholder="请上传文件">
          <template #input>
            <uploadFiles :disabled="isDisabled('fj')" :files="formData.fj" @success="uploadSuccess" module-type="flow" 
             @fileRemove="(removedFile)=>handleFileRemove(removedFile,'formData','fj')"></uploadFiles>
          </template>
        </van-field>
      </van-cell-group>
      <div style="display: flex;">
        <div  class="font-32 font-weight-500 cor-00 m-t-26 m-b-26">
          出差明细
        </div>
        <div class="width-80 m-t-10">
          <van-notice-bar color="#ed6a0c" background="rgb(247,247,247)" @click="tripDetail" left-icon="info-o">
            请确保您的出差行程形成一个完...
            <!-- 请确保您的出差行程形成一个完整的闭环，即每个出发和返程都应有相应的行程单。每张交通票据应对应一个明确的行程，若存在中转，每个中转点也需单独生成行程。例如，若您从A城市出发，经B城市中转最终到达C城市，您需要提交的行程单应包括从A到B、从B到C以及从C返回A的行程。请按照这一要求规划和填写您的行程，以确保顺利审批和报销。 -->
          </van-notice-bar>
        </div>
      </div>
      <van-cell-group v-for="(item,index) in formData.ccmxb" :key="index" class="b-r-10 m-t-20">
        <div style="border-bottom: 1px solid #EBEBEB" class="p-b-20">
          <van-row type="flex" align="center">
            <van-col :span="22">
              <img class="w-5 h-28" :src="`${image_base_url}/icon_line.png`"></img>
              <span class="cor-33 font-weight-500 font-28 m-l-16">{{ `明细${index + 1}` }}</span>
            </van-col>
            <van-col v-if="isShowIcon('ccmxb')" @click="removeItem(index,'ccmxb')" :span="2">
              <img class="w-30 h-30" :src="`${image_base_url}/shoppingDel.png`"></img>
            </van-col>
          </van-row>
        </div>

        <van-field v-f-show="'xch'" :required="isRequired('xch')" :value="item.xch" :rules="getRules('xch')" label="行程号" input-align="right" readonly>
          <template #input>
            <!--            <view-item :value="formData.flowNo + '_' + (index + 1)"/>-->
            {{ item.xch = formData.flowNo + '_' + (index + 1) }}
          </template>
        </van-field>


        <van-field v-f-show="'cfsj'" v-model="item.cfsj" :required="isRequired('cfsj')" name="cfsj" label="出发时间"
                   placeholder="出发时间" input-align="right" :rules="getRules('cfsj')">
          <template #input>
            <view-item @click.native="popupShow(cfsj.show,index,'cfsj')" :value="item.cfsj" placeholder="请选择出发时间"/>
            <van-calendar :min-date="new Date(2010, 1, 1)" v-model="cfsj.show[index]" ref="cfsj" :show-confirm="false" title="选择出发时间"
                          @confirm="(date) => {cfsjConfirm(date,item,index)}"></van-calendar>
          </template>
        </van-field>


        <van-field v-f-show="'fromCity'" v-model="item.fromCity" name="fromCity" :required="isRequired('fromCity')" :rules="getRules('fromCity')" label="出发城市" placeholder="出发城市" input-align="right">
          <template #input>
            <view-item @click.native="popupShow(fromCity.show,index,'fromCity')" :value="item.fromCity" placeholder="请选择出发城市"/>
            <van-popup position="bottom" v-model="fromCity.show[index]">
              <van-nav-bar title="选择出发城市" left-text="取消" right-text="确定" @click-left="popupHidden(fromCity.show,index)" @click-right="fromCityPopupSubmit(item,index)"/>
              <van-search v-model="fromCity.filterText[index]" @input="treeSearch($event,$refs[`fromCityTree_${index}`])" clearable shape="round"/>
              <div style="overflow-y: auto" class="h-vh-35">
                <div class="p-10">
                  <el-tree :ref="`fromCityTree_${index}`" @check-change="singleChoice($event,$refs[`fromCityTree_${index}`],index)" node-key="id" check-strictly :data="fromCity.data" :filter-node-method="filterNode" check-on-click-node show-checkbox/>
                </div>
              </div>
            </van-popup>
          </template>
        </van-field>


        <van-field v-f-show="'toCity'" v-model="item.toCity" name="toCity" :required="isRequired('toCity')" :rules="getRules('toCity')" label="到达城市" placeholder="到达城市" input-align="right">
          <template #input>
            <view-item @click.native="popupShow(toCity.show,index,'toCity')" :value="item.toCity" placeholder="请选择到达城市"/>
            <van-popup position="bottom" v-model="toCity.show[index]">
              <van-nav-bar title="选择到达城市" left-text="取消" right-text="确定" @click-left="popupHidden(toCity.show,index)" @click-right="toCityPopupSubmit(item,index)"/>
              <van-search v-model="toCity.filterText[index]" @input="treeSearch($event,$refs[`toCityTree_${index}`])" clearable shape="round"/>
              <div style="overflow-y: auto" class="h-vh-35">
                <div class="p-10">
                  <el-tree :ref="`toCityTree_${index}`" @check-change="singleChoice($event,$refs[`toCityTree_${index}`],index)" node-key="id" check-strictly :data="toCity.data" :filter-node-method="filterNode" check-on-click-node show-checkbox/>
                </div>
              </div>
            </van-popup>
          </template>
        </van-field>


        <van-field v-f-show="'sfzs'" input-align="right" name="sfzs" :rules="getRules('sfzs')"
                   :required="isRequired('sfzs')" :value="item.sfzs" label="是否住宿" placeholder="请选择是否住宿">
          <template #input>
            <view-item @click.native="popupShow(sfzs.show,index,'sfzs')" :value="item.sfzs"
                       placeholder="请选择是否住宿"/>
            <van-popup v-model="sfzs.show[index]" position="bottom">
              <van-nav-bar title="选择是否住宿" left-text="取消" right-text="确定"
                           @click-left="popupHidden(sfzs.show,index)" @click-right="sfzsSubmit(item,index)"/>
              <van-search v-model="sfzs.filterText" @input="pickerSearch($event,sfzs)" clearable
                          shape="round"/>
              <van-picker :ref="`sfzsPicker_${index}`" value-key="name" :columns="sfzs.filteredData"
                          @cancel="sfzs.show = false"/>
            </van-popup>
          </template>
        </van-field>


        <van-field v-f-show="'jtgj'" input-align="right" name="jtgj" :rules="getRules('jtgj')"
                   :required="isRequired('jtgj')" :value="item.jtgj" label="交通工具" placeholder="请选择交通工具">
          <template #input>
            <view-item @click.native="popupShow(jtgj.show,index,'jtgj')" :value="item.jtgj"
                       placeholder="请选择交通工具"/>
            <van-popup v-model="jtgj.show[index]" position="bottom">
              <van-nav-bar title="选择交通工具" left-text="取消" right-text="确定"
                           @click-left="popupHidden(jtgj.show,index)" @click-right="jtgjSubmit(item,index)"/>
              <van-search v-model="jtgj.filterText" @input="pickerSearch($event,jtgj)" clearable
                          shape="round"/>
              <van-picker :ref="`jtgjPicker_${index}`" value-key="name" :columns="jtgj.filteredData"
                          @cancel="jtgj.show = false"/>
            </van-popup>
          </template>
        </van-field>

        <van-field v-f-show="'lksj'" v-model="item.lksj" :required="isRequired('lksj')" name="lksj" label="离开时间"
                   placeholder="离开时间" input-align="right" :rules="getRules('lksj')">
          <template #input>
            <view-item @click.native="popupShow(lksj.show,index,'lksj')" :value="item.lksj" placeholder="请选择离开时间"/>
            <van-calendar :min-date="new Date(2010, 1, 1)" v-model="lksj.show[index]" ref="lksj" :show-confirm="false" title="选择离开时间"
                          @confirm="(date) => {lksjConfirm(date,item,index)}"></van-calendar>
          </template>
        </van-field>


      </van-cell-group>
      <van-row v-if="!isDisabled('ccmxb')">
        <van-col :span="12"></van-col>
        <van-col :span="12">
          <van-button icon="add-o" round native-type="button" color="#FFDA3E" text="添加出差明细" @click="addCcItem" class="width-100"/>
        </van-col>
      </van-row>


    </van-form>
    <div class="font-32 font-weight-500 cor-00 m-t-26">流程</div>
    <!--      这个是不带选人的流程图    -->
    <flowTrace v-if="!$route.query.reSend && (processInstanceId || $route.query.processInstanceId)" class="m-t-20"
               :flowTraceList="flowTrace" :processInfo="processData"></flowTrace>
    <!--      这个是带选人的流程图    -->
    <approver v-else class="m-t-20" ref="approver" @addUser="addUser" :processData="processData" :formData="formData" :formItemMap="formItemMap"/>
    <bottom-bar @submit="submit" @mention="mention"></bottom-bar>
    <van-popup position="bottom" v-model="approver.show">
      <van-nav-bar title="选择办理人" left-text="取消" right-text="确定" @click-left="approver.show = false"
                   @click-right="approverPopupSubmit"/>
      <van-search v-model="approver.filterText" @input="treeSearch($event, $refs.approverTree)" clearable
                  shape="round"/>
      <div style="overflow-y: auto" class="h-vh-50">
        <div class="p-10">
          <el-tree ref="approverTree" @check-change="approverCheckChange($event, $refs.approverTree)" node-key="uuid"
                   check-strictly :data="approver.data" :filter-node-method="filterNode" check-on-click-node
                   show-checkbox/>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import {getCurrentUserDept, getDeptUserTreeAll, selectMyProjectList} from '@/api/user.js'
import {getFormDataByInstanceId} from "@/api/flow";
import cache from "@/plugins/cache";
import mixin from '@/mixin/flow'
import moment from "moment";
import {getDictDataByType, provinceTree} from '@/api/dict'
import uploadFiles from "@/components/uploadFiles/index.vue";
import fileMixins from "@/components/uploadFiles/fileMixins";
import bottomBar from '@/components/flow/bottom-bar.vue'
import flowTrace from '@/components/flow/flowTrace.vue'
import approver from "@/components/flow/approver.vue";
import {Dialog} from 'vant';


const ccItem = {
  xch: "",
  cfsj: "",
  fromCity: "",
  toCity: "",
  sfzs: "",
  jtgj: "",
  lksj: ''
}
export default {
  components: {approver, bottomBar, flowTrace, uploadFiles, Dialog},
  mixins: [mixin,fileMixins],
  watch: {},
  data() {
    return {
      moment,
      formData: {
        flowNo: "",
        sqr: "",
        ssbm: "",
        sy: "",
        // 出差时间
        ccsj: [],
        // 出差天数
        ccts: null,
        ccmxb: [{
          xch: "",
          cfsj: "",
          fromCity: "",
          toCity: "",
          sfzs: "",
          jtgj: "",
          lksj: ''
        }],
        fj: []
      },
      rules: {},
      ccsj: {
        show: false
      },
      // 计划时间
      jhsj: {
        show: [],
      },
      sjsj: {
        show: [],
      },
      sfzs: {
        data: ['是', '否'],
        show: [],
        filteredData: ['是', '否'],
        filterText: '',
      },
      fromCity: {
        data: [],
        // 有多个popup时，需要一个数组来保存
        show: [],
        filterText: [],
      },
      toCity: {
        data: [],
        show: [],
        filterText: [],
      },
      cfsj: {
        show: [],
      },
      lksj: {
        show: [],
      },
      // 所属部门
      ssbm: {
        data: [],
        filteredData: [],
        filterText: '',
        show: false
      },
      // 选人树
      approver: {
        data: [],
        filterText: '',
        show: false
      },
      // 部门用户树
      deptUserTreeAll: {
        data: [],
        filterText: '',
        show: false
      },
      // 交通工具字典
      jtgj: {
        data: [],
        show: [],
        filteredData: [],
        filterText: '',
      },
      // 所属项目
      ssxm: {
        data: [],
        show: false,
        filteredData: [],
        filterText: '',
      },
      formItemMap: null, // 表单字段的Map
    }
  },
  created() {
    const {templateId, groupId, reSend} = this.$route.query
    this.SET_TEMPLATE_ID(templateId)
    this.SET_GROUP_ID(groupId)
    this.init()
    if (reSend && this.$route.query.processInstanceId) { // 重新发起时
      this.$loading.show()
      this.getFormInfo({templateId: this.templateId}).then(res => {
        this.formItemMap = new Map( res.data?.currentNode?.props?.formPerms.map(item => [item.id, item]))
        // 从后台去流程表单数据 只取fomData
        getFormDataByInstanceId(this.$route.query.processInstanceId).then(form => {
          // 合并
          Object.assign(this.formData, res.data.processTemplates.expressVals, form.data)
          this.$loading.hide()
        })
      })
    } else if (this.$route.query.processInstanceId && !this.$route.query.reSend) { // 外部跳转时
      this.SET_PROCESS_INSTANCE_ID(this.$route.query.processInstanceId)
      if (this.$route.query.taskId) {
        this.SET_TASK_ID(this.$route.query.taskId)
      }
      this.$loading.show()
      this.getProcessInfo({
        processInstanceId: this.$route.query.processInstanceId,
        taskId: this.$route.query.taskId
      }).then(res => {
        Object.assign(this.formData, res.data.formData)
        this.$loading.hide()
      })
    } else { // 新增时
      // 新增时调用
      this.getFormInfo({templateId: this.templateId, groupId: this.groupId}).then(res => {
        this.formItemMap = new Map( res.data?.currentNode?.props?.formPerms.map(item => [item.id, item]))
        Object.assign(this.formData, res.data.processTemplates.expressVals)
        this.formData.ccmxb[0].xch = this.formData.flowNo + '_1'
      })
      // 新增时 初始化的时候预定人是当前登录用户
      const currentUserInfo = JSON.parse(cache.session.get("userInfo"))
      this.getCurrentUserDept(currentUserInfo)
      this.selectMyProjectList(currentUserInfo)
    }
  },
  methods: {
    init() {
      // 获取部门用户树
      this.getDeptUserTreeAll()
      // 省市树
      this.getProvinceTree()
      // 交通工具 trafic_type
      getDictDataByType('trafic_type').then(res => {
        const data = res.data.map(item => {
          return item.dictLabel
        })
        this.jtgj.data = data
        this.jtgj.filteredData = data
      })
    },
    jtgjSubmit(item, index) {
      item.jtgj = this.$refs[`jtgjPicker_${index}`][0].getValues()[0];
      this.popupHidden(this.jtgj.show, index)
    },
    sfzsSubmit(item, index) {
      item.sfzs = this.$refs[`sfzsPicker_${index}`][0].getValues()[0];
      this.popupHidden(this.sfzs.show, index)
    },
    getProvinceTree() {
      provinceTree().then(res => {
        this.fromCity.data = res.data
        this.toCity.data = res.data
      })
    },
    ccsjConfirm(date) {
      this.formData.ccsj = date.map(item => {
        return moment(item).format('YYYY-MM-DD')

      })
      this.ccsj.show = false
      this.formData.ccts = moment(this.formData.ccsj[1]).diff(this.formData.ccsj[0], 'days') 
      
    },
    fromCityPopupSubmit(item, index) {
      item.fromCity = this.$refs[`fromCityTree_${index}`][0]?.getCheckedNodes()[0]?.id
      this.popupHidden(this.fromCity.show, index)
    },
    toCityPopupSubmit(item, index) {
      item.toCity = this.$refs[`toCityTree_${index}`][0]?.getCheckedNodes()[0]?.id
      this.popupHidden(this.toCity.show, index)
    },
    addCcItem() {
      let item = JSON.parse(JSON.stringify(ccItem))
      this.formData.ccmxb.push(item)
    },
    uploadSuccess(fileList) { // 每次都会filelist全部丢出来
      this.formData.fj = fileList
    },
    cfsjConfirm(date, item, index) {
      this.$set(this.cfsj.show, index, false);
      // 单个时间
      item.cfsj = moment(date).format('YYYY-MM-DD')
    },
    lksjConfirm(date, item, index) {
      this.$set(this.lksj.show, index, false);
      // 单个时间
      item.lksj = moment(date).format('YYYY-MM-DD')
    },
    // 计划时间日历确认事件
    jhsjConfirm(date, index, item) {
      this.$set(this.jhsj.show, index, false);
      const jhsj = date.map(da => {
        return moment(da).format('YYYY-MM-DD')
      })
      item.jhsj = jhsj
      // 计算计划天数
      item.jhts = moment(jhsj[1]).diff(jhsj[0], 'days')
    },
    // 实际时间
    sjsjConfirm(date, index, item) {
      this.$set(this.sjsj.show, index, false);
      const sjsj = date.map(da => {
        return moment(da).format('YYYY-MM-DD')
      })
      item.sjsj = sjsj
      // 计算计划天数
      item.sjts = moment(sjsj[1]).diff(sjsj[0], 'days')
    },
    removeItem(index, field) {
      if (this.formData[field].length === 1) return this.$toast('请至少保留一项')
      this.$dialog.confirm({
        message: '确定删除该项吗？',
      }).then(() => {
        this.formData[field].splice(index, 1)
      })
    },
    // 获取人员所属部门列表
    getCurrentUserDept(user) {
      return new Promise(resolve => {
        getCurrentUserDept({userId: user.id || user.userId}).then(res => {
          this.ssbm.data = res.data
          // 搜索过滤
          this.ssbm.filteredData = this.ssbm.data
          resolve(res.data)
        })
      })
    },
    // 人员、部门树
    getDeptUserTreeAll() {
      const _this = this
      getDeptUserTreeAll().then(res => {
        // 递归处理this.deptUserTreeAll，添加禁用状态和uuid
        const data = this._getDeptUserTreeAll(res.data[0].children)
        this.$nextTick(() => {
          this.$set(this.deptUserTreeAll, 'data', data)
          this.$set(this.approver, 'data', data)
        })
      })
    },
    // 获取人员所属项目列表
    selectMyProjectList(user) {
      return new Promise(resolve => {
        selectMyProjectList({projectMember: user.id || user.userId}).then(res => {
          this.ssxm.data = res.rows
          this.ssxm.filteredData = res.rows
          resolve(res.rows)
        })
      })
    },
    // 显示明细提醒
    tripDetail() {
      Dialog.alert({
        title: '填写明细提醒',
        message: '请确保您的出差行程形成一个完整的闭环，即每个出发和返程都应有相应的行程单。每张交通票据应对应一个明确的行程，'+
        '若存在中转，每个中转点也需单独生成行程。例如，若您从A城市出发，经B城市中转最终到达C城市，您需要提交的行程单应包括从A到B、'+
        '从B到C以及从C返回A的行程。请按照这一要求规划和填写您的行程，以确保顺利审批和报销。',
        theme: 'round-button',
      }).then(() => {
        // on close
      });
    }
  }
}

</script>
